import { createContext, useContext } from "react";
import { type SelectedStudentId, type SelectedStudentIdContext } from "./types";

export const selectedStudentIdInitialValue: SelectedStudentId = 0;

export const selectedStudentIdInitialState: SelectedStudentIdContext = {
  selectedStudentId: selectedStudentIdInitialValue,
  setStudentId: () => {},
};

const context = createContext<SelectedStudentIdContext>(
  selectedStudentIdInitialState,
);
export const useSelectedStudentIdContext = () => useContext(context);
export const SelectedStudentIdContextProvider = context.Provider;
